import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { PropertyCard, EmptyProperties } from "@/pages/dashboard/Properties";
import { Plus } from "lucide-react";

function greeting() {
  const h = new Date().getHours();
  return h < 13 ? "Buongiorno" : h < 18 ? "Buon pomeriggio" : "Buonasera";
}

export default function Overview() {
  const { user } = useAuth();
  const [props, setProps] = useState(null);
  useEffect(() => { api.get("/properties").then(({ data }) => setProps(data.properties)); }, []);

  return (
    <div className="px-4 pt-8">
      <p className="text-slate-400 text-sm font-medium">{greeting()},</p>
      <h1 className="font-display font-extrabold text-3xl tracking-tight text-slate-900">{user?.first_name || user?.name} 👋</h1>

      <Link to="/dashboard/properties/new" data-testid="overview-create" className="mt-6 flex items-center justify-center gap-2 bg-blue-500 text-white font-semibold rounded-2xl py-4 shadow-lg shadow-blue-500/25 active:scale-[0.99] transition-transform">
        <Plus className="w-5 h-5" /> Crea una nuova struttura
      </Link>

      <div className="mt-8 flex items-center justify-between">
        <h2 className="font-display font-bold text-lg text-slate-900">Le tue strutture</h2>
        {props?.length > 0 && <Link to="/dashboard/properties" className="text-sm font-semibold text-blue-600">Vedi tutte</Link>}
      </div>

      {!props ? <div className="py-16 grid place-items-center"><div className="w-6 h-6 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" /></div>
        : props.length ? <div className="mt-4 space-y-4">{props.slice(0, 6).map((p) => <PropertyCard key={p.id} p={p} onDeleted={(id) => setProps((x) => x.filter((y) => y.id !== id))} />)}</div>
        : <EmptyProperties />}
    </div>
  );
}
